// extracted by mini-css-extract-plugin
export var standaloneTable = "_ei-0";
export var standaloneTableWithBodyFill = "_ei-1";
export var withExtraHeader = "_ei-2";